module.exports = __webpack_public_path__ + "img/Weapon_271.985f71cb.png";